import VisitorsByDayChart from './VisitorsByDayChart';
import VisitorsByHourChart from './VisitorsByHourChart';
import VisitsByDayChart from './VisitsByDayChart';
import VisitsByHourChart from './VisitsByHourChart';

const TrafficPastWeekPanel = () => {
  return (
    <>
      <VisitorsByHourChart />
      <VisitorsByDayChart />
      <VisitsByHourChart />
      <VisitsByDayChart />
    </>
  );
};

export default TrafficPastWeekPanel;
